<!-- IMPORTANT: This file need to be kept in sync with /src/routes/+page.svelte -->
<script>
  import Entry from "#lib/Entry.svelte";
  import PageError from "#lib/PageError.svelte";
  let { data } = $props();
</script>

<div class="entry-page">
  {#if data.status !== 200}
    <PageError status={data.status} message={data.message} />
  {:else}
    <Entry
      additional_entry_data={data.additional_entry_data}
      raw_entry={data.entry}
      is_homepage={data.is_homepage}
    />
  {/if}
</div>

<style>
  /* Wrapper uses display:contents to avoid layout impact while providing scopable element */
  .entry-page { display: contents; }
  
  /* Global style for stable scrollbars when navigating between pages */
  :global(html) {
    scrollbar-gutter: stable;
  }
</style>